import React from 'react'

import { CompanySearchVisual } from '@/components/announcements/DiscoveryIntroModal/visuals'

export const CompanyIntelligencePreview: React.FC = () => (
  <figure className="relative my-6 h-[194px] overflow-hidden rounded-xl border border-primary-200 bg-gradient-to-b from-accent-400/15 via-violet-500/[0.06] to-transparent dark:border-primary-800">
    <CompanySearchVisual />
    <figcaption className="sr-only">
      A natural-language web search returning relevant company websites and
      public profiles with current descriptions and source links.
    </figcaption>
  </figure>
)

export default CompanyIntelligencePreview
